import React from "react";
import { AxiosAuth } from "../../core/axios";
import Notification from "rsuite/Notification";
import toaster from "rsuite/toaster";
import Loader from "rsuite/Loader";
import { saveAs } from 'file-saver';
import { AxiosRequestConfig } from "axios";

const MessageDownloading = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification ref={ref} type="info" header="Info" closable duration={0}>
      <Loader size="md" content="Downloading" />
    </Notification>
  )
);

const MessageDownloaded = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification
      ref={ref}
      type="success"
      header="Success"
      duration={2000}
      closable
    >
      Download Complete. Saving data...
    </Notification>
  )
);

const MessageDownloadError = React.forwardRef<HTMLDivElement, {}>(
  (_, ref): JSX.Element => (
    <Notification
      ref={ref}
      type="error"
      duration={2000}
      header="error"
      closable
    >
      Error downloading data.
    </Notification>
  )
);
export function base64ToUint8Array(file: string) {
  var raw = atob(file);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  for (var i = 0; i < rawLength; i += 1) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}


async function FetchAndBuildDataUrl(endpoint: string): Promise<string | null> {

  let axiosConfig: AxiosRequestConfig = {
    responseType: "arraybuffer",
    headers: { Accept: "*/*" }
  }
  try {
    const response = await AxiosAuth.get(endpoint, axiosConfig);
    const URL = window.URL.createObjectURL(new Blob([response.data]));
    return URL;
  } catch (e) {
    return null;
  }
}

async function DownloadExport(
  endpoint: string,
  fileName: string
): Promise<void> {
  const startId = toaster.push(<MessageDownloading />, { placement: "topEnd" });
  const dataUrl = await FetchAndBuildDataUrl(endpoint);
  toaster.remove(startId as string);
  setTimeout(() => {
    if (dataUrl !== null) {
      const downloadedToastId = toaster.push(<MessageDownloaded />, {
        placement: "topEnd",
      });
      const link = document.createElement('a');
      link.href = dataUrl || "";
      link.setAttribute('download', `${fileName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => toaster.remove(downloadedToastId as string), 2000);
      link.remove();
    } else {
      const errorToastId = toaster.push(<MessageDownloadError />, {
        placement: "topEnd",
      });
      setTimeout(() => toaster.remove(errorToastId as string), 2000);
    }
  }, 500);
}

export const LibExport = {
  DownloadExport,
};
